import { CallbackObject } from 'api/core/get-page-function';
import { instance } from 'api/core';

export const assignTeamToCircuit = async (
    circuitId: string,
    teamId: string,
    callback: CallbackObject<void>
) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        await instance.patch(`/picking/circuits/${circuitId}/team/${teamId}/assign`, {}, config);
        callback.success();
    } catch (err) {
        if (callback.error) callback.error(err);
    }
};
